angular
  .module 'filters'
  .filter 'membershipPlanTermFilter', ($filter) ->
    (plan) ->
      if plan.term_number
        $filter('pluralize')(plan.term_unit, plan.term_number, true)
      else
        'N/A'
